import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        setUser(res.data);
        // Clean the hash
        window.history.replaceState(null, "", window.location.pathname);
        if (res.data.is_admin) {
          navigate("/admin", { replace: true, state: { user: res.data } });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/admin/login?error=auth_failed", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0A1128] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#D4AF37]/30 border-t-[#D4AF37] rounded-full animate-spin mx-auto mb-6" />
        <p className="text-[#D4AF37] uppercase tracking-[0.25em] text-xs">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
